import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05e3ee12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3ee12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e3ee12')) {
      api.createRecord('05e3ee12', component.options)
    } else {
      api.reload('05e3ee12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05e3ee12&scoped=true", function () {
      api.rerender('05e3ee12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/index.vue"
export default component.exports